import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { EvCore } from 'ev-core';
import { INewDwellingProspectUnits } from 'src/app/infopage/new-new-dwelling/newdwelling.model';

type CompactMode = 'total' | 'soldUnsold';

interface StatRow {
    label: string;
    suffix?: string;
    total: number;
    sold: number;
    unsold: number;
}

@Component({
    selector: 'statistics-compact',
    templateUrl: './statistics-compact.component.html',
    styleUrl: './statistics-compact.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe, EvCore],
})
export class StatisticsCompactComponent {
    prospectUnits = input<INewDwellingProspectUnits>();
    subtitle = input<string>('');

    mode = signal<CompactMode>('total');

    rows = computed<StatRow[]>(() => {
        const t = this.prospectUnits()?.totalStatisticsValues;
        const s = this.prospectUnits()?.totalStatisticsSoldValues;
        const u = this.prospectUnits()?.totalStatisticsUnsoldValues;

        return [
            { label: 'Enheter',   total: t?.numberOfUnits,      sold: s?.numberOfUnits,      unsold: u?.numberOfUnits },
            { label: 'm²-pris',   total: t?.avaragePricePerSqm, sold: s?.avaragePricePerSqm, unsold: u?.avaragePricePerSqm },
            { label: 'Snittpris', total: t?.avaragePrice,        sold: s?.avaragePrice,        unsold: u?.avaragePrice },
            { label: 'Snitt m²',  suffix: ' m²', total: t?.avarageSqm, sold: s?.avarageSqm,  unsold: u?.avarageSqm },
            { label: 'Tot verdi', total: t?.totalPrice,          sold: s?.totalPrice,          unsold: u?.totalPrice },
        ];
    });

    setMode(mode: CompactMode): void {
        this.mode.set(mode);
    }
}
